(function () {
  var STORE_CONFIG = {
    co: {
      origin: 'https://co.deliciossobymatthew.com',
      languages: {
        es: '',
        en: '/en'
      }
    },
    intl: {
      origin: 'https://deliciossobymatthew.com',
      languages: {
        en: '',
        es: '/es'
      }
    }
  };

  var CANONICAL_PATH_ALIASES = {
    '/collections': '/collections',
    '/collections/all': '/collections',
    '/collections/coffee': '/collections/coffee',
    '/collections/cafe': '/collections/coffee',
    '/collections/cafes': '/collections/coffee',
    '/collections/mugs': '/collections/mugs',
    '/collections/tazas': '/collections/mugs',
    '/collections/t-shirts': '/collections/t-shirts',
    '/collections/t-shirt': '/collections/t-shirts',
    '/collections/camisetas': '/collections/t-shirts',
    '/collections/caps': '/collections/caps',
    '/collections/gorras': '/collections/caps',
    '/collections/merch': '/collections/merch'
  };

  var COLLECTION_HANDLE_ALIASES = {
    all: '',
    coffee: 'coffee',
    cafe: 'coffee',
    cafes: 'coffee',
    mugs: 'mugs',
    tazas: 'mugs',
    't-shirts': 't-shirts',
    't-shirt': 't-shirts',
    camisetas: 't-shirts',
    caps: 'caps',
    gorras: 'caps',
    merch: 'merch'
  };

  var PRODUCT_HANDLE_ALIASES = {
    'cafe-mattu': 'cafe-mattu',
    'cafe-mattu-sabor-del-bosque': 'cafe-mattu',
    'caffe-mattu': 'cafe-mattu',
    'coffee-mattu': 'cafe-mattu'
  };

  var STORE_ROUTE_MAP = {
    co: {
      es: {
        '/collections': '/collections',
        '/collections/coffee': '/collections/coffee',
        '/collections/mugs': '/collections/tazas',
        '/collections/t-shirts': '/collections/camisetas',
        '/collections/caps': '/collections/gorras',
        '/collections/merch': '/collections/merch'
      },
      en: {
        '/collections': '/en/collections',
        '/collections/coffee': '/en/collections/coffee',
        '/collections/mugs': '/en/collections/mugs',
        '/collections/t-shirts': '/en/collections/t-shirt',
        '/collections/caps': '/en/collections/caps',
        '/collections/merch': '/en/collections/merch'
      }
    },
    intl: {
      en: {
        '/collections': '/collections',
        '/collections/coffee': '/collections/coffee',
        '/collections/mugs': '/collections/mugs',
        '/collections/t-shirts': '/collections/t-shirts',
        '/collections/caps': '/collections/caps',
        '/collections/merch': '/collections/merch'
      },
      es: {
        '/collections': '/es/collections',
        '/collections/coffee': '/es/collections/coffee',
        '/collections/mugs': '/es/collections/tazas',
        '/collections/t-shirts': '/es/collections/camisetas',
        '/collections/caps': '/es/collections/gorras',
        '/collections/merch': '/es/collections/merch'
      }
    }
  };

  function normalizeHost(host) {
    return String(host || '').toLowerCase().replace(/^www\./, '');
  }

  function isInternationalHost(host) {
    return normalizeHost(host) === 'deliciossobymatthew.com';
  }

  function detectLanguageFromPath(pathname, store) {
    var nextPath = String(pathname || '/').trim();

    if (!nextPath) {
      return store === 'co' ? 'es' : 'en';
    }

    if (nextPath.charAt(0) !== '/') {
      nextPath = '/' + nextPath;
    }

    nextPath = nextPath.replace(/\/{2,}/g, '/');

    if (nextPath === '/es' || nextPath === '/es/' || nextPath.indexOf('/es/') === 0) {
      return 'es';
    }

    if (nextPath === '/en' || nextPath === '/en/' || nextPath.indexOf('/en/') === 0) {
      return 'en';
    }

    return store === 'co' ? 'es' : 'en';
  }

  function normalizeCanonicalPath(path) {
    var nextPath = String(path || '/').trim();

    if (!nextPath) {
      return '/';
    }

    if (/^https?:\/\//i.test(nextPath)) {
      try {
        nextPath = new URL(nextPath).pathname || '/';
      } catch (error) {
        nextPath = '/';
      }
    }

    if (nextPath.charAt(0) !== '/') {
      nextPath = '/' + nextPath;
    }

    nextPath = nextPath.replace(/\/{2,}/g, '/');

    if (nextPath === '/en' || nextPath === '/en/' || nextPath === '/es' || nextPath === '/es/') {
      nextPath = '/';
    } else if (nextPath.indexOf('/en/') === 0 || nextPath.indexOf('/es/') === 0) {
      nextPath = nextPath.slice(3) || '/';
    }

    if (!nextPath) {
      return '/';
    }

    if (nextPath.length > 1 && nextPath.charAt(nextPath.length - 1) === '/') {
      nextPath = nextPath.slice(0, -1);
    }

    return nextPath || '/';
  }

  function canonicalizeCollectionPath(path) {
    var normalizedPath = normalizeCanonicalPath(path);
    var collectionMatch = normalizedPath.match(/^\/collections\/([^/]+)(\/.*)?$/);

    if (!collectionMatch) {
      return CANONICAL_PATH_ALIASES[normalizedPath] || normalizedPath;
    }

    var rawHandle = collectionMatch[1];
    var remainder = collectionMatch[2] || '';
    var canonicalHandle = COLLECTION_HANDLE_ALIASES[rawHandle];

    if (rawHandle === 'all') {
      return remainder || '/collections';
    }

    if (!canonicalHandle) {
      return normalizedPath;
    }

    return '/collections/' + canonicalHandle + remainder;
  }

  function canonicalizeProductPath(path) {
    var normalizedPath = canonicalizeCollectionPath(path);
    var productMatch = normalizedPath.match(/^(.*)\/products\/([^/]+)$/);

    if (!productMatch) {
      return normalizedPath;
    }

    var productPrefix = productMatch[1] || '';
    var rawHandle = productMatch[2];
    var canonicalHandle = PRODUCT_HANDLE_ALIASES[rawHandle] || rawHandle;

    return productPrefix + '/products/' + canonicalHandle;
  }

  function canonicalizeCatalogPath(path) {
    return canonicalizeProductPath(path);
  }

  function localizeCollectionHandle(store, language, canonicalHandle) {
    if (canonicalHandle === 'mugs') {
      return language === 'es' ? 'tazas' : 'mugs';
    }

    if (canonicalHandle === 't-shirts') {
      if (store === 'co' && language === 'en') {
        return 't-shirt';
      }

      if (language === 'es') {
        return 'camisetas';
      }

      return 't-shirts';
    }

    if (canonicalHandle === 'caps') {
      return language === 'es' ? 'gorras' : 'caps';
    }

    return canonicalHandle;
  }

  function localizeProductHandle(store, canonicalHandle) {
    if (canonicalHandle === 'cafe-mattu' && store === 'intl') {
      return 'cafe-mattu-sabor-del-bosque';
    }

    return canonicalHandle;
  }

  function localizeCanonicalPath(store, language, canonicalPath) {
    var normalizedPath = canonicalizeCatalogPath(canonicalPath);
    var productMatch = normalizedPath.match(/^(.*)\/products\/([^/]+)$/);

    if (productMatch) {
      var productPrefix = productMatch[1] || '';
      var canonicalProductHandle = productMatch[2];
      var localizedProductHandle = localizeProductHandle(store, canonicalProductHandle);
      var localizedPrefix = productPrefix ? localizeCanonicalPath(store, language, productPrefix) : '';

      return localizedPrefix + '/products/' + localizedProductHandle;
    }

    var collectionMatch = normalizedPath.match(/^\/collections\/([^/]+)(\/.*)?$/);

    if (!collectionMatch) {
      return normalizedPath;
    }

    var canonicalHandle = collectionMatch[1];
    var remainder = collectionMatch[2] || '';
    var localizedHandle = localizeCollectionHandle(store, language, canonicalHandle);

    return '/collections/' + localizedHandle + remainder;
  }

  function buildStorePath(store, language, canonicalPath) {
    var storeConfig = STORE_CONFIG[store];
    if (!storeConfig) {
      throw new Error('Unknown store "' + store + '"');
    }

    var localePrefix = storeConfig.languages[language];
    if (localePrefix === undefined) {
      throw new Error('Unsupported language "' + language + '" for store "' + store + '"');
    }

    var normalizedPath = canonicalizeCatalogPath(canonicalPath);
    var mappedRoutes = STORE_ROUTE_MAP[store] && STORE_ROUTE_MAP[store][language];
    var nextPath = mappedRoutes && mappedRoutes[normalizedPath];

    if (!nextPath) {
      nextPath = localizeCanonicalPath(store, language, normalizedPath);
      if (localePrefix) {
        nextPath = nextPath === '/' ? localePrefix : localePrefix + nextPath;
      }
    }

    if (!nextPath || nextPath.charAt(0) !== '/') {
      nextPath = '/' + (nextPath || '');
    }

    return nextPath;
  }

  function buildStoreUrl(store, language, canonicalPath) {
    var storeConfig = STORE_CONFIG[store];
    if (!storeConfig) {
      throw new Error('Unknown store "' + store + '"');
    }

    return storeConfig.origin + buildStorePath(store, language, canonicalPath);
  }

  function getSanitizedInternationalPath(pathname, search, hash) {
    var language = detectLanguageFromPath(pathname, 'intl');
    var nextPath = buildStorePath('intl', language, pathname);
    return nextPath + (search || '') + (hash || '');
  }

  function normalizeInternalIntlHref(href) {
    if (!href) {
      return null;
    }

    var parsedUrl;
    try {
      parsedUrl = new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }

    if (!isInternationalHost(parsedUrl.hostname)) {
      return null;
    }

    var sanitizedPath = getSanitizedInternationalPath(parsedUrl.pathname, parsedUrl.search, parsedUrl.hash);
    var currentPath = parsedUrl.pathname + (parsedUrl.search || '') + (parsedUrl.hash || '');
    if (sanitizedPath === currentPath) {
      return null;
    }

    return sanitizedPath;
  }

  function fixInternationalLinks(scope) {
    if (!isInternationalHost(window.location.hostname)) {
      return;
    }

    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('a[href]'), function (link) {
      var sanitizedHref = normalizeInternalIntlHref(link.getAttribute('href'));
      if (sanitizedHref) {
        link.setAttribute('href', sanitizedHref);
      }
    });
  }

  function redirectInvalidInternationalLocation() {
    if (!isInternationalHost(window.location.hostname)) {
      return;
    }

    var pathname = window.location.pathname || '/';
    var nextPath = getSanitizedInternationalPath(pathname, window.location.search, window.location.hash);
    var currentPath = pathname + (window.location.search || '') + (window.location.hash || '');
    if (nextPath !== currentPath) {
      window.location.replace(nextPath);
    }
  }

  function storageAvailable(type) {
    try {
      var storage = window[type];
      var testKey = '__deliciosso_test__';
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function readStorage(key) {
    if (!storageAvailable('localStorage')) return '';
    return window.localStorage.getItem(key) || '';
  }

  function writeStorage(key, value) {
    if (!storageAvailable('localStorage')) return;
    window.localStorage.setItem(key, value);
  }

  function readCookie(name) {
    var cookieName = encodeURIComponent(name) + '=';
    var cookies = String(window.document.cookie || '').split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return decodeURIComponent(cookie.slice(cookieName.length));
      }
    }
    return '';
  }

  function writeCookie(name, value, days) {
    var maxAge = typeof days === 'number' ? '; max-age=' + String(days * 24 * 60 * 60) : '';
    var secure = window.location.protocol === 'https:' ? '; secure' : '';
    window.document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(value) +
      maxAge +
      '; path=/; domain=.deliciossobymatthew.com' +
      secure +
      '; samesite=lax';
  }

  function getStorePreference() {
    return readCookie('deliciosso_store_preference');
  }

  function setStorePreference(value) {
    var store = String(value || '').toLowerCase();
    if (store !== 'co' && store !== 'intl') {
      return;
    }

    writeCookie('deliciosso_store_preference', store, 14);
  }

  function getLanguagePreference() {
    var language = String(readCookie('deliciosso_language_preference') || '').toLowerCase();
    if (language !== 'es' && language !== 'en') {
      return '';
    }

    return language;
  }

  function setLanguagePreference(value) {
    var language = String(value || '').toLowerCase();
    if (language !== 'es' && language !== 'en') {
      return;
    }

    writeCookie('deliciosso_language_preference', language, 14);
  }

  function getGeoStoreRoute(countryCode, pathname) {
    var normalizedCountryCode = String(countryCode || '').toUpperCase();

    if (normalizedCountryCode === 'CO') {
      return {
        store: 'co',
        language: detectLanguageFromPath(pathname, 'intl')
      };
    }

    if (normalizedCountryCode === 'VE') {
      return {
        store: 'intl',
        language: 'es'
      };
    }

    return null;
  }

  function detectBot() {
    var agent = String((window.navigator && window.navigator.userAgent) || '').toLowerCase();
    if (!agent) return false;
    return (
      agent.indexOf('bot') !== -1 ||
      agent.indexOf('crawl') !== -1 ||
      agent.indexOf('spider') !== -1 ||
      agent.indexOf('slurp') !== -1 ||
      agent.indexOf('bingpreview') !== -1
    );
  }

  function shouldAutoRedirectByIp(pathname) {
    var normalizedPath = normalizeCanonicalPath(pathname);
    return normalizedPath === '/';
  }

  function fetchCountryCode() {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve('');
      }, 2500);

      window.fetch('https://ipapi.co/json/', {
        credentials: 'omit',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) return '';
          return response.json();
        })
        .then(function (payload) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          if (!payload || typeof payload !== 'object') {
            resolve('');
            return;
          }
          resolve(String(payload.country_code || payload.countryCode || payload.country || '').toUpperCase());
        })
        .catch(function () {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve('');
        });
    });
  }

  function maybeAutoRedirectByIp() {
    if (detectBot()) {
      return;
    }

    if (!isInternationalHost(window.location.hostname)) {
      return;
    }

    var pathname = window.location.pathname || '/';
    if (/^\/(cart|checkout|account|orders)(\/|$)/.test(pathname)) {
      return;
    }
    if (!shouldAutoRedirectByIp(pathname)) {
      return;
    }

    var search = window.location.search || '';
    var hash = window.location.hash || '';
    var currentUrl = window.location.origin + pathname + search + hash;

    var storedPreference = getStorePreference();
    var storedLanguagePreference = getLanguagePreference();
    if (storedPreference === 'intl') {
      if (storedLanguagePreference === 'es') {
        var intlSpanishUrl = buildStoreUrl('intl', 'es', pathname) + search + hash;
        if (intlSpanishUrl !== currentUrl) {
          window.location.replace(intlSpanishUrl);
        }
      }
      return;
    }
    if (storedPreference === 'co') {
      var preferredLanguage = storedLanguagePreference || detectLanguageFromPath(pathname, 'co');
      var coUrl = buildStoreUrl('co', preferredLanguage, pathname) + search + hash;
      if (coUrl !== currentUrl) {
        window.location.replace(coUrl);
      }
      return;
    }

    fetchCountryCode().then(function (countryCode) {
      var geoRoute = getGeoStoreRoute(countryCode, pathname);
      if (!geoRoute) {
        return;
      }

      var nextUrl = buildStoreUrl(geoRoute.store, geoRoute.language, pathname) + search + hash;
      if (nextUrl === currentUrl) {
        return;
      }

      window.location.replace(nextUrl);
    });
  }

  function initStoreSwitcher() {
    var root = document.querySelector('[data-store-switcher]');
    if (!root || root.dataset.initialized === 'true') {
      return;
    }
    root.dataset.initialized = 'true';

    var select = root.querySelector('[data-store-switcher-select]');
    if (!select) {
      return;
    }

    var currentStore = root.getAttribute('data-current-store') || 'intl';
    var currentLanguage = root.getAttribute('data-current-language') || 'en';

    function withCurrentSearchAndHash(url) {
      return url + (window.location.search || '') + (window.location.hash || '');
    }

    function getActiveCanonicalPath() {
      return canonicalizeCatalogPath(window.location.pathname || root.getAttribute('data-canonical-path') || '/');
    }

    Array.prototype.forEach.call(select.options, function (option) {
      var optionStore = option.getAttribute('data-store');
      var optionLanguage = option.getAttribute('data-language');
      if (!optionStore || !optionLanguage) {
        return;
      }

      option.value = withCurrentSearchAndHash(buildStoreUrl(optionStore, optionLanguage, getActiveCanonicalPath()));

      if (optionStore === currentStore && optionLanguage === currentLanguage) {
        select.value = option.value;
      }
    });

    select.addEventListener('change', function () {
      var selectedOption = select.options[select.selectedIndex];
      if (!selectedOption) {
        return;
      }

      var targetStore = selectedOption.getAttribute('data-store');
      var targetLanguage = selectedOption.getAttribute('data-language');
      if (!targetStore || !targetLanguage) {
        return;
      }

      var nextUrl = withCurrentSearchAndHash(buildStoreUrl(targetStore, targetLanguage, getActiveCanonicalPath()));
      setStorePreference(targetStore);
      setLanguagePreference(targetLanguage);
      window.location.assign(nextUrl);
    });

    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target && event.target.closest
          ? event.target.closest('[data-store-switcher-accept], [data-store-switcher-prompt-link]')
          : null;

        if (!trigger) {
          return;
        }

        var targetStore = String(trigger.getAttribute('data-target-store') || '').toLowerCase();
        if (targetStore === 'colombia') {
          targetStore = 'co';
        } else if (targetStore === 'international') {
          targetStore = 'intl';
        }

        if (targetStore !== 'co' && targetStore !== 'intl') {
          return;
        }

        setStorePreference(targetStore);
        if (targetStore === 'co' || targetStore === 'intl') {
          var targetLanguage = String(trigger.getAttribute('data-target-language') || '').toLowerCase();
          if (targetLanguage === 'es' || targetLanguage === 'en') {
            setLanguagePreference(targetLanguage);
          }
        }
      },
      true
    );
  }

  function initInternationalRouteGuard() {
    redirectInvalidInternationalLocation();
    fixInternationalLinks(document);

    if (isInternationalHost(window.location.hostname) && typeof MutationObserver === 'function' && document.body) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (node && node.nodeType === 1) {
              fixInternationalLinks(node);
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        if (!link) {
          return;
        }

        var sanitizedHref = normalizeInternalIntlHref(link.getAttribute('href'));
        if (!sanitizedHref) {
          return;
        }

        link.setAttribute('href', sanitizedHref);

        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
          return;
        }

        event.preventDefault();
        window.location.assign(sanitizedHref);
      },
      true
    );
  }

  window.Deliciosso = window.Deliciosso || {};
  window.Deliciosso.buildStoreUrl = buildStoreUrl;
  window.Deliciosso.normalizeStoreSwitcherPath = canonicalizeCatalogPath;
  window.Deliciosso.normalizeStoreSwitcherRawPath = normalizeCanonicalPath;
  window.Deliciosso.normalizeInternalIntlHref = normalizeInternalIntlHref;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initInternationalRouteGuard();
      maybeAutoRedirectByIp();
      initStoreSwitcher();
    });
    return;
  }

  initInternationalRouteGuard();
  maybeAutoRedirectByIp();
  initStoreSwitcher();
})();
